import { css } from '@emotion/core';

const buttonGroupStyle = css`
  @media (max-width: 320px) {
    & {
      /* ensure buttons can be maximum width: */
      width: 100%;
      /* icon buttons aren't full-width, so they should be placed in the
       * center of the group:
       */
      justify-content: center;
    }
  }
`;

export default buttonGroupStyle;
